import moment from 'moment';

/**
 * Offre transfert : pas de remise tout de suite (les convertisseurs J+2/J+3 paient plein tarif).
 * Remise auto -10% uniquement entre H+96 et H+120 (24h d'urgence vers J+4).
 */
export const TRANSFER_OFFER_DELAY_HOURS = 96;
export const TRANSFER_OFFER_DURATION_HOURS = 24;
export const TRANSFER_OFFER_END_HOURS = TRANSFER_OFFER_DELAY_HOURS + TRANSFER_OFFER_DURATION_HOURS; // 120

/** Au bout de 30 jours, l'ancre est effacée : le user redevient comme un nouveau. */
export const TRANSFER_OFFER_COOLDOWN_DAYS = 30;

/** Clé dans user.dates */
export const TRANSFER_OFFER_DATE_KEY = 'transferOfferStartedAt';
export const TRANSFER_OFFER_MAILS_KEY = 'transferOfferMails';

/** @deprecated Utiliser TRANSFER_OFFER_END_HOURS ; gardé pour imports existants. */
export const TRANSFER_OFFER_WINDOW_HOURS = TRANSFER_OFFER_END_HOURS;

/**
 * Scénario B (depuis le transfert).
 * H+0 : mail transactionnel conversation/new (hors drip).
 * Relances H+24 / 72 / 96 / 108 : automation Brevo (liste « Transfert sans commande »).
 * L'app ne fait plus que la sortie de liste à H+120 (ou dès commande).
 */
export const TRANSFER_OFFER_MAIL_STEPS = [
	{ hours: 120, mailKey: 'h120done', template: null },
];

export function getTransferOfferStartedAt(user) {
	return (user && user.dates && user.dates[TRANSFER_OFFER_DATE_KEY]) || null;
}

/**
 * Heures écoulées depuis le démarrage d'offre (ancre transfert), ou null si aucune ancre.
 */
export function getHoursSinceTransferOffer(user, now = moment.utc()) {
	const started = getTransferOfferStartedAt(user);
	if(!started) {
		return null;
	}
	return now.diff(moment.utc(started), 'hours', true);
}

/**
 * true si on peut poser / reposer l'ancre (pas d'ancre, ou 30 jours écoulés).
 */
export function canStartOrResetTransferOffer(startedAt, now = Date.now()) {
	if(!startedAt) {
		return true;
	}
	const startedMs = new Date(startedAt).getTime();
	if(Number.isNaN(startedMs)) {
		return true;
	}
	const cooldownMs = TRANSFER_OFFER_COOLDOWN_DAYS * 24 * 60 * 60 * 1000;
	return now >= startedMs + cooldownMs;
}
